import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useLenis, scrollTo } from "@/lib/lenis";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { QuickContact } from "@/components/QuickContact";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import ServiceDetail from "@/pages/ServiceDetail";
import UeberUns from "@/pages/UeberUns";
import Termin from "@/pages/Termin";
import Kontakt from "@/pages/Kontakt";
import FaqPage from "@/pages/FaqPage";
import { Impressum, Datenschutz, Agb } from "@/pages/Legal";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollTo(hash, { offset: -90, duration: 1.4 }), 120);
      return () => clearTimeout(t);
    }
    scrollTo(0, { immediate: true });
    return undefined;
  }, [pathname, hash]);
  return null;
}

function Layout() {
  useLenis();
  return (
    <>
      <ScrollManager />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:bg-white focus:px-4 focus:py-2 focus:rounded-full">Zum Inhalt springen</a>
      <Nav />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
      <QuickContact />
      <Toaster position="top-center" richColors />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/leistungen/:slug" element={<ServiceDetail />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/termin" element={<Termin />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<Agb />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
